<template>
  <div>
    <Tab
      :items="[
        'Instructions',
        'Assign subscriptions',
        'Subscriptions',
        'VPS',
        'Invoices'
      ]"
      :selected="selectedTab"
      @selected="ChangeTab($event)"
    ></Tab>

    <div v-if="selectedTab === 0" class="content">
      <p>
        <b>Need a help?</b>
        <br />
        <a
          href="mailto:support@deployify.io?subject=Deployify Licensing - help"
        >support@deployify.io</a>
      </p>
      <h2 class="title is-size-5">1. Server License</h2>
      <p>
        How to generate and transfer the license to your Deployify servers. All
        servers will have the same license.
      </p>
      <ol>
        <li>
          Go to
          <a @click="ChangeTab(1)">Assign subscriptions</a>.
        </li>
        <li>Click on "Generate License".</li>
        <li>
          When the license is generated, click on "License" to download the
          license.
        </li>
        <li>
          Put the downloaded license file in "{installDir}/api/config/". The
          file should be named "license.json".
        </li>
        <li>Restart the server.</li>
        <li>Your server will appear in the "Servers" view.</li>
      </ol>

      <h2 class="title is-size-5">2. Subscriptions</h2>
      <p>How to subscribe and assign subscriptions to your server.</p>
      <ol>
        <li>
          Go to
          <a @click="ChangeTab(2)">Subscriptions</a>.
        </li>
        <li>Subscribe on a plan that fits your needs.</li>
        <li>
          Go to
          <a @click="ChangeTab(1)">Assign subscriptions</a>.
        </li>
        <li>
          Click on "Assign Subscriptions" on the server that you would like to
          assign subscriptions to, and pick the subscriptions that the server
          should have.
        </li>
        <li>Now, sign in on your Deployify server.</li>
        <li>Click on any domain.</li>
        <li>
          Click on the "burger" menu (in the nav bar) and click on "Global
          license".
        </li>
        <li>Click on the "Update" button.</li>
        <li>
          "Total" should now be the sum of the number of computers in the
          assigned subscriptions.
        </li>
      </ol>

      <h2 class="title is-size-5">3. Manage Computer License</h2>
      <p>
        <b>Your server handles this automatically</b>, but this is how you do it
        manually.
      </p>
      <ol>
        <li>Right-click on a computer.</li>
        <li>Click on "Manage license".</li>
        <li>Here you can assign or remove a license for that computer.</li>
      </ol>
    </div>

    <License v-if="selectedTab === 1"></License>
    <Subscriptions v-if="selectedTab === 2"></Subscriptions>
    <VpsScriptions v-if="selectedTab === 3"></VpsScriptions>
    <Invoices v-if="selectedTab === 4"></Invoices>
  </div>
</template>

<script>
import Tab from "@/components/singles/BTab/component.vue";

export default {
  components: {
    License: () => import("@/components/main/license/servers/component.vue"),
    Subscriptions: () =>
      import("@/components/main/subscriptions/component.vue"),
    VpsScriptions: () =>
      import("@/components/main/vps/subscriptions/component.vue"),
    Invoices: () => import("@/components/main/invoices/component.vue"),
    Tab
  },
  data() {
    return {
      selectedTab: 0,
      visible: false
    };
  },
  created() {
    if (this.$route.query.tab) {
      this.selectedTab = parseInt(this.$route.query.tab);
    }
  },
  mounted() {},
  beforeDestroy() {
    this.$router.push({ query: {} });
  },
  methods: {
    ChangeTab(tabNumber) {
      if (this.selectedTab != tabNumber) {
        this.selectedTab = tabNumber;
        this.$router.push({ query: { tab: tabNumber } });
      }
    }
  }
};
</script>
